module.exports = __webpack_public_path__ + "img/D_read_more_driving.2d6abf2b.svg";